export default __webpack_public_path__ + "static/media/zmdss.631bba02.png";